<template>
  <div v-if="visa_request.track">
    <v-toolbar class="elevation-0 hide-on-print" color="none">
      <v-toolbar-title class="text-primary">
        <b>{{ dependent_visa !== visaTypeName ? dependent_visa : '' }}{{ visaTypeName }} <span
            style="color: #212020;font-size: 15px;">({{ condition_name }})</span>
          ({{ visa_request.visa_plan_name }}) </b>
        <v-chip class="text-white" color="red" v-if="visa_request.payment_info.total > 0">
          Unpaid
        </v-chip>
        <v-chip class="text-white" color="primary" v-else>
          Free
        </v-chip>
      </v-toolbar-title>
      <v-spacer />
    </v-toolbar>

    <v-card-text class="pt-0">
      <v-layout class=" pt-0" row wrap>
        <v-flex xs12 v-if="visa_request.appointment_date">
          <v-alert type="error" outlined>
            The visa request have appointment date of {{ visa_request.appointment_date }}
          </v-alert>
        </v-flex>
        <v-flex xs12 v-if="visa_request.extra && visa_request.extra.has_recommendation_letter === true">
          <v-alert outlined type="info">
            Applicant has recommendation letter for free Visa.
          </v-alert>
        </v-flex>
        <v-flex xs12 v-if="visa_request.extra.blacklisted_country && visa_request.extra.blacklisted_country === true">
          <v-alert outlined type="error">
            Applicant is from prohibited country.He can not apply for visa without recommendation letter.Please ask for
            recommendation letter.
          </v-alert>
        </v-flex>
        <v-flex xs12 v-if="visa_request.extra.i_am_nrn">
          <v-alert outlined type="info">
            Applicant is an NRN.
          </v-alert>
        </v-flex>

        <v-flex xs12 v-if="visa_request.extra.apply_type === 'entry'">
          <v-alert outlined type="info">
            This visa is entry visa.
          </v-alert>
        </v-flex>

        <v-flex xs12 v-if="visa_request.extra.has_recommendation_letter">
          <v-alert outlined type="info">
            Applicant has recommendation letter for free Visa.
          </v-alert>
        </v-flex>

        <v-flex class="mx-2" v-if="showLateDays" xs12>
          <v-alert outlined type="error">
            This visa is <b>{{ visa_request.late_days }}</b> days late <span
              v-if="visa_request.verified_late_days > 0 && visa_request.late_days != visa_request.verified_late_days && !visa_request.approve_rejected">and
              <b>{{ visa_request.verified_late_days }}</b> days late while verifying</span>
          </v-alert>
        </v-flex>

        <!--                    Overstay Processing Alert-->
        <v-flex xs12 v-if="visa_request.overstay_processing">
          <v-alert outlined type="info">
            This request is overstay processing.
          </v-alert>
        </v-flex>
        <!--          checking if the person is in interpol record-->
        <v-alert outlined type="error" v-if="visa_request.interpol_hit">
          Interpol hit found. Immediately contact to INTERPOL (9851285950/ 01-4412836/ 01-4430411)
        </v-alert>
        <v-flex class="mx-2" v-if="visa_request.blacklists.length > 0" xs12>
          <v-alert outlined type="error">Similar record matching to this person information is found in
            blacklist.
            <v-spacer />
          </v-alert>
        </v-flex>

        <black-list-detail :black_lists="visa_request.blacklists" :traveller_id="visa_request.traveller.id"
          @unmarked="unmarked" />

        <attached-document :document_list="visa_request.applied_documents" :show-btn="!visa_request.verified"
          v-if="visa_request.applied_documents.length > 0" />

        <v-flex xs12 v-if="visa_request.required_documents">
          <v-divider class="my-1" />
        </v-flex>

        <attached-required-document :document_list="visa_request.required_documents"
          :submission_no="visa_request.submission_no" :is_verified="visa_request.verified"
          v-if="visa_request.required_documents" />

        <v-flex xs12>
          <v-divider class="my-1" />
        </v-flex>
        <v-flex xs12 v-if="visa_request.existing_visa_visit" class="ma-2">
          <v-alert type="info" outlined>
            Traveller`s last visa on system is <b>{{ visa_request.existing_visa_visit.type }}</b> (Visa No:
            <b>{{ visa_request.existing_visa_visit.visa_number }}</b> & Visa Period:
            <b>{{ visa_request.existing_visa_visit.start_date.substr(0, 10) }}</b>
            to <b>{{ visa_request.existing_visa_visit.expiry_date }}</b>)
          </v-alert>
        </v-flex>
        <v-flex class="row pl-5" xs12>
          <v-icon left medium>mdi-equal-box</v-icon>
          <span class="font-weight-bold" style="color: black; font-size: 15px;">
            Requested Visa Details ({{ visa_request.visa_status }})
            <v-tooltip top v-if="visa_request.old_visa_verified">
              <template v-slot:activator="{ on }">
                <v-btn @click="editForm" class="mr-2" color="#FF8316" dark dense fab v-on="on" x-small>
                  <v-icon small>edit</v-icon>
                </v-btn>
              </template>
              <span>Edit information</span>
            </v-tooltip>
          </span>
        </v-flex>
        <v-flex class="mx-2" v-if="visa_request.watch_list.length > 0" xs12>
          <v-alert outlined type="info">
            Similar record matching to this personal information is found in Watch lists.
          </v-alert>
        </v-flex>
        <v-flex class="mx-2" v-if="!visa_request.old_visa_verified" xs12>
          <v-alert outlined type="info">
            The previous visa is not verified yet . Please verify old visa before verifying this one
          </v-alert>
        </v-flex>
        <v-flex class="pl-3" sm3 xs12 v-if="visa_request.extra.visa_number">
          <list-item-detail :sub_title="visa_request.extra.visa_number" title="Visa number" />
        </v-flex>
        <v-flex class="pl-3" sm3 xs12 v-else>
          <list-item-detail :sub_title="visa_request.submission_no" title="Submission Id" />
        </v-flex>
        <v-flex sm3 xs12>
          <list-item-detail
            :sub_title="(visa_request.start_date ? visa_request.start_date : 'N/A') + ' to ' + expiry_date + ' (' + visa_request.days + ' days)'"
            title="Visa Duration" />
        </v-flex>

        <v-flex sm3 xs12>
          <list-item-detail :sub_title="visa_request.created_at" title="Applied At" />
        </v-flex>

        <v-flex class="pr-3" sm3 xs12 v-if="visa_request.visa_type_slug === 'tourist-visa'">
          <v-text-field hide-details label="Previous Stay" outlined disabled
            v-model="visa_request.days_stayed.countable_days_stayed"></v-text-field>
        </v-flex>
        <v-flex xs12 v-if="!visa_request.existing_visa_visit">
          <v-divider class="my-1" />
        </v-flex>
        <v-flex xs12>
          <component v-bind:is="visa_request.visa_type_slug" />
        </v-flex>
        <v-flex xs12>
          <v-divider class="my-1" />
        </v-flex>
        <v-layout class="row wrap mx-0" v-if="visa_request.extra.previous_visa">
          <v-flex class="d-flex justify-content-between" xs12>
            <confirmation-header-text class="ml-2" icon="mdi-equal-box" text="Current Visa Details" />

            <v-btn @click="view(visa_request.previous_visa.submission_no)" color="primary" dark dense small text>
              View Details
            </v-btn>

          </v-flex>

          <v-flex class="ml-2" sm3 xs12>
            <list-item-detail :sub_title="visa_request.previous_visa.visa_number" title="Visa number" />
          </v-flex>

          <v-flex sm3 xs12>
            <list-item-detail :sub_title="visa_request.previous_visa.visa_type" title="Visa Type" />
          </v-flex>

          <v-flex sm3 xs12>
            <list-item-detail
              :sub_title="visa_request.previous_visa.start_date + ' to ' + visa_request.previous_visa.expiry_date"
              title="Visa Duration" />
          </v-flex>

          <v-flex xs12>
            <v-divider class="my-1" />
          </v-flex>
        </v-layout>

        <traveller-detail :mobile_number="visa_request.extra.mobile_number" />
        <v-flex xs12>
          <v-divider class="my-1" />
        </v-flex>

        <v-flex class="ml-2" lg12 md12 sm12 v-if="visa_request.payment_info.total > 0">
          <confirmation-header-text class="pl-3" icon="mdi-alpha-p-box" text="Payment Info" />
        </v-flex>

        <v-flex class="pl-3" v-if="visa_request.payment_info.voucher_number" xs3>
          <list-item-detail :sub_title="visa_request.payment_info.voucher_number" title="Voucher number" />
        </v-flex>
        <v-flex class="pl-3" v-if="visa_request.payment_info.total > 0" xs3>
          <list-item-detail :sub_title="visa_request.payment_info.total" title="Total cost(USD)" />
        </v-flex>
        <v-flex v-if="visa_request.payment_info.visa_amount > 0" xs3>
          <list-item-detail :sub_title="visa_request.payment_info.visa_amount" title="Visa Fee(USD)" />
        </v-flex>
        <v-flex v-if="visa_request.payment_info.late_stay_cost > 0" xs3>
          <list-item-detail :sub_title="visa_request.payment_info.late_stay_cost" title="Late Fee(USD)" />
        </v-flex>
        <v-flex v-if="visa_request.payment_info.overstay_cost > 0" xs3>
          <list-item-detail :sub_title="visa_request.payment_info.overstay_cost" title="OverStay Fee(USD)" />
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-footer class="sticky" color="blue lighten-2" fixed height="auto" v-if="visa_request.can_process">
      <!--      <v-layout row v-if="!visa_request.verified && !visa_request.check_payment_status_only" wrap>-->
      <!--      V if edited while solving kanchanur visa issue-->
      <v-layout row v-if="!visa_request.verified" wrap>
        <v-spacer />
        <v-btn :loading="loading" @click="verifyOldVisa" class="text-white ml-2" color="primary"
          v-if="visa_request.verify_old_visa">
          Verify old visa
        </v-btn>
        <!-- <v-btn :loading="loading" @click="verifyVisa" class="text-white ml-2" color="primary" v-if="showVerify">
          Verify
        </v-btn> -->

        <div :key="visa_request.submission_no">
<!--          <v-btn :loading="loading" @click="verifyVisa" class="text-white ml-2" color="primary" v-if="showVerify">-->
<!--            Verify-->
<!--          </v-btn>-->
          <v-btn :loading="loading" @click="verifyVisa" class="text-white ml-2" color="primary" v-if="$oauth.checkIfHasPermission(['read visa-transfer']) && $oauth.checkIfHasPermission(['verify visa-transfer'])">
            Verify
          </v-btn>
        </div>


        <!--            v-if="visa_request.can_verify_visa && !visa_request.check_payment_status_only"-->
        <v-btn @click="reject" class="white--text ml-2" color="red lighten-1 " v-if="visa_request.can_verify_visa">
          Reject
        </v-btn>
      </v-layout>
      <v-layout row v-if="visa_request.check_payment_status_only" wrap>
        <v-spacer />
        <v-btn @click="checkPaymentStatusOnly" class="text-white ml-2" color="primary"
          v-if="visa_request.voucher_number">
          Check Payment
        </v-btn>
      </v-layout>
    </v-footer>
    <reject-modal-ui />
    <unapproved-visa-edit-dialog v-model="manualEditDialog" />

    <v-dialog v-model="showPassportValidityDialog" width="500">
      <v-card>
        <v-card-title class="headline white lighten-2">
          Alert !
        </v-card-title>

        <v-card-text>
          <span style="color: black; font-size:14px; ">This {{
            visa_request.passport_document.document_type === 'Travel Document' ?
              visa_request.passport_document.document_type : 'Passport'
          }} is going to expire in less than 6 months. Are you sure to proceed ?</span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="showPassportValidityDialog = false">
            Cancel
          </v-btn>
          <v-btn color="primary" text @click="verify">
            Proceed Anyway
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import ListItemDetail from "../../../components/ListItemDetail";

import FileListItemDetail from "../../../components/FileListItemDetail";
import AttachedDocument from "../../../components/AttachedDocument";
import moment from "moment"

import TouristVisa from "@/components/visa-types/confirm/TouristVisa";
import StudyVisa from "@/components/visa-types/confirm/StudyVisa";
import BusinessVisa from "@/components/visa-types/confirm/BusinessVisa";
import RelationVisa from "@/components/visa-types/confirm/RelationVisa";
import TransitVisa from "@/components/visa-types/confirm/TransitVisa";
import MarriageVisa from "@/components/visa-types/confirm/MarriageVisa";
import ResidentialVisa from "@/components/visa-types/confirm/ResidentialVisa";
import NRNVisa from "@/components/visa-types/confirm/NRNVisa";
import PressVisa from "@/components/visa-types/confirm/PressVisa";
import DependentVisa from "../../../components/visa-types/confirm/DependentVisa";
import DependentStudyVisa from "../../../components/visa-types/confirm/DependentStudyVisa";
import DependentWorkingVisa from "../../../components/visa-types/confirm/DependentWorkingVisa";
import DependentBusinessVisa from "../../../components/visa-types/confirm/DependentBusinessVisa";
import DependentPressVisa from "../../../components/visa-types/confirm/DependentPressVisa";
import DependentMarriageVisa from "../../../components/visa-types/confirm/DependentMarriageVisa";
import DependentRelationVisa from "../../../components/visa-types/confirm/DependentRelationVisa";
import DependentDiplomatic from "../../../components/visa-types/confirm/DependentDiplomaticVisa";
import FileDisplay from "../../../components/FileDisplay";
import ConfirmationHeaderText from "../../../components/ConfirmationHeaderText";
import WorkingVisa from "../../../components/visa-types/confirm/WorkingVisa";
import VisaRejectModal from "../../../components/visa/VisaRejectModal";
import { validationMixin } from "../../../mixins/validationMixin";
import BlackListDetail from "../../../components/visa/BlackListDetail";
import PrintDialog from "../../../components/dialogs/PrintDialog";

import TravellerDetail from './TravellerDetail';
import Print from "../../trekking/trekking-request/TrekkingRequestPrint";
import UnapprovedVisaEditDialog from "../../../components/dialogs/UnapprovedVisaEditDialog";
import visa_request from "../../../store/modules/visa-request/visa_request";
import DependentOfficialVisa from "@/components/visa-types/confirm/DependentOfficialVisa";
import AttachedRequiredDocument from "../../../components/AttachedRequiredDocument";
import { VERSIONED_API_URL } from '../../../config/config'
import axios from 'axios';
import ExportExcelButton from "../../../components/ExportExcelButton.vue";

const year_logs = [{
  year: new Date().getFullYear(),
  visa_type: null,
  days_stayed: 0
}];
const years = [];
for (let i = new Date().getFullYear(); i > 2017; i--) {
  years.push(i)
}

export default {
  name: "UnPaidVisaDetail",
  props: [
    'visa_request',
  ],
  mixins: [validationMixin],
  components: {
    ExportExcelButton,
    AttachedRequiredDocument,
    UnapprovedVisaEditDialog,
    Print,
    BlackListDetail,
    ListItemDetail,
    FileDisplay,
    ConfirmationHeaderText,
    "tourist-visa": TouristVisa,
    'study-visa': StudyVisa,
    'business-visa': BusinessVisa,
    'relation-visa': RelationVisa,
    'transit-visa': TransitVisa,
    'marriage-visa': MarriageVisa,
    'residential-visa': ResidentialVisa,
    'nrn-visa': NRNVisa,
    'dependent-visa': DependentVisa,
    'dependent-study-visa': DependentStudyVisa,
    'dependent-working-visa': DependentWorkingVisa,
    'dependent-business-visa': DependentBusinessVisa,
    'dependent-marriage-visa': DependentMarriageVisa,
    'dependent-press-visa': DependentPressVisa,
    'dependent-relation-visa': DependentRelationVisa,
    'dependent-diplomatic-visa': DependentDiplomatic,
    'dependent-official-visa': DependentOfficialVisa,
    AttachedDocument,
    'working-visa': WorkingVisa,
    'press-visa': PressVisa, FileListItemDetail,
    "reject-modal-ui": VisaRejectModal,
    TravellerDetail,
    PrintDialog
  },
  data() {
    return {
      hide: false,
      year_logs,
      years,
      loading: false,
      manualEditDialog: false,
      showPassportValidityDialog: false,
      verifyOption: false,
      printedStatus: false,
      printEnabledCondition: false
    }
  },
  computed: {
    showLateDays() {
      return this.visa_request.late_days > 0 && !this.visa_request.approve_rejected;
    },
    showVerify() {
      const { can_verify_visa, verified, old_visa_verified, verify_old_visa } = this.visa_request;
      console.log('verifyOption is: ', this.verifyOption);

      //old  
      // return can_verify_visa && !verified && old_visa_verified && !verify_old_visa;

      //new with verify option and printed status conditions
      if (this.printEnabledCondition && this.visa_request.office_id && this.visa_request.office_id === 1) {
        return can_verify_visa && !verified && old_visa_verified && !verify_old_visa && this.verifyOption && this.printedStatus;
      }
      return can_verify_visa && !verified && old_visa_verified && !verify_old_visa

    },
    condition_name() {
      if (this.visa_request.visa_type_condition)
        return this.visa_request.visa_type_condition.name;
    },
    visaTypeName() {
      return this.visa_request.visa_type;
    },
    documents() {
      let passport = this.visa_request.traveller_document;
      let documents = [];
      if (passport) {
        documents =
          [{
            type: 'passport',
            number: passport.document_number,
            validity: passport.validity
          }];
      }
      return documents;
    },
    expiry_date() {
      const { expiry_date, start_date, days } = this.visa_request;
      if (expiry_date) {
        return expiry_date;
      }
      // Delete below code after august
      return moment(start_date).add(days, 'Days').subtract('1', 'days').format('YYYY-MM-DD')
    },
    visa_types() {
      return this.$store.state.VisaTypeList.all;
    },
    dependent_visa() {
      let { visa_type_slug, dependent, visa_type } = this.visa_request;
      if (dependent) {
        return visa_type
      }
      return ''
    },

  },
  /*watch: {

    verifyOption(val) {
      console.log("verifyOption changed to:", val);
    },
    printedStatus(val) {
      console.log("printedStatus changed to:", val);
    },
    showVerify(val) {
      console.log("showVerify updated to:", val);
    }
  },*/
  watch: {
    visa_request: {
      immediate: true,
      deep: true,
      handler(newVal) {
        console.log("visa_request changed:", newVal);
        if (newVal && newVal.submission_no) {
          this.fetchVerifySettings(newVal.submission_no);
        }
      }
    },
    printedStatus(val) {
      console.log("printedStatus changed to:", val);
    },
    showVerify(val) {
      console.log("showVerify updated to:", val);
    },
  }

  ,
  methods: {
    ...mapActions(
      'VisaRequestSingle', [
      'getVisaRequestDetail',
      'checkPaymentStatusOnly',
      'checkPaymentStatusOnly',
      'verifyRequest',
      "verifyOldVisaRequest"
    ]),
    unmarked(id) {
      this.visa_request.blacklists = this.visa_request.blacklists.filter((i) => i.id !== id);
    },
    editForm() {
      this.manualEditDialog = true;
    },
    async verifyOldVisa() {
      await this.$dialog.confirm({
        text: "Are you sure to verify the visa request ?",
        title: "Verify Visa Request !",
        actions: {
          false: "No",
          true: {
            color: "blue",
            text: "Yes",
            handle: async () => {
              await this.verifyOldVisaRequest();
            }
          }
        }
      });

    },
    view(submission_no) {
      window.open('/admin/system/visa-requests/view/' + submission_no, '_blank')
    },
    reject() {
      this.$store.commit("VisaRequestSingle/setRejectModal", true);
    },


    verifyVisa() {
      let validity = moment(this.visa_request.passport_document.validity);
      let today = moment();
      if (!validity.isSameOrBefore(today) && validity.diff(today, 'months') < 6)
        this.showPassportValidityDialog = true;
      else
        this.verify();
    },
    async verify() {
      this.showPassportValidityDialog = false;
      await this.$dialog.confirm({
        text: "Are you sure to verify the visa request ? The visa request details cannot be edited after verification.",
        title: "Confirmation !",
        actions: {
          false: {
            color: "red",
            text: "No"
          },
          true: {
            color: "green",
            text: "Yes",
            handle: async () => {
              this.loading = true;
              try {
                await this.verifyRequest();
                this.loading = false;
              } catch (e) {
                this.$store.commit('Notification/showError', e.response.data.message);
                this.loading = false;
                throw e;
              }
            }
          }
        }
      });
    },
    async fetchVerifySettings(submission_no) {
      try {
        const verifyOptionRes = await axios.get(`${VERSIONED_API_URL}/settings/get-verify-option`);
        this.verifyOption = verifyOptionRes.data.verify_option === '1' || verifyOptionRes.data.verify_option === true;
        if (this.verifyOption) {
          this.printEnabledCondition = true;
        }
        console.log("Verify Option (from settings):", this.verifyOption);
      } catch (e) {
        console.error("Failed to fetch verify option:", e);
      }

      try {
        const externalRes = await axios.get(`${VERSIONED_API_URL}/proxy/token-status`, {
          params: { code: submission_no }
        });

        let status = null;

        if (
          externalRes &&
          externalRes.data &&
          externalRes.data.data &&
          typeof externalRes.data.data.status === "string"
        ) {
          status = externalRes.data.data.status;
        }

        this.printedStatus = status === "printed";
        console.log("External API raw:", externalRes.data);
        console.log("Is printedStatus:", this.printedStatus);
      } catch (e) {
        console.error("Failed to fetch external visa status:", e);
      }
    }
  },
  async mounted() {
    const submission_no = this.visa_request.submission_no;

    // Fetching verify option set in settings via redis
    try {
      //checking printed status from  redis Api
      const verifyOptionRes = await axios.get(`${VERSIONED_API_URL}/settings/get-verify-option`);
      this.verifyOption = verifyOptionRes.data.verify_option === '1' || verifyOptionRes.data.verify_option === true;
      if (this.verifyOption) {
        this.printEnabledCondition = true
      }
      console.log("Verify Option (from settings):", this.verifyOption);
    } catch (e) {
      console.error("Failed to fetch verify option:", e);
    }

    try {
      // Fetching printed status from external API for verification
      const externalRes = await axios.get(`${VERSIONED_API_URL}/proxy/token-status`, {
        params: { code: submission_no }
      });

      let status = null;

      if (
        externalRes &&
        externalRes.data &&
        externalRes.data.data &&
        typeof externalRes.data.data.status === "string"
      ) {
        status = externalRes.data.data.status;
      }

      this.printedStatus = status === "printed";
      console.log("External API raw:", externalRes.data);
      console.log("Is printedStatus:", this.printedStatus);
    } catch (e) {
      console.error("Failed to fetch external visa status:", e);
    }
  }

}
</script>
